// @ts-ignore
import pbi from "powerbi-client";
import {UserStateEx} from "../../../api/models-ex/user-state-ex";
import {DialogResultType} from "../../../dialogs/DialogResult";
import {MessageDialogComponent} from "../../../dialogs/message-dialog/message-dialog.component";
import {ConfirmDialogComponent} from "../../../dialogs/confirm-dialog/confirm-dialog.component";
import {InteractivesService} from "../../../api/services/interactives.service";
import {US_Interactive} from "../../../api/models/us_interactive";
import {UserState} from "../../../api/models/user-state";
import {MatDialog} from "@angular/material/dialog";
import {GlobalApp} from "../../../tools/global";
import {InteractReportsEx} from "../../../api/models/interact-reports-ex";
import {US_ReportExport} from "../../../api/models/us_report-export";
import {InteractReports} from "../../../api/models/interact-reports";
import {
  ReportExportDialogComponent,
  ReportExportDialogData
} from "../../../dialogs/report-export-dialog/report-export-dialog.component";
import {ReportExportDetails} from "../../../api/models/report-export-details";
import {SubInteractReportExports} from "../../../api/models/sub-interact-report-exports";
import {Router} from "@angular/router";
import {SubscriptionService} from "../../../api/services/subscription.service";

export class ReportService {

  public interactReports: InteractReportsEx[] = [];
  public interactReportExports: US_ReportExport[] = [];

  activeReport: InteractReports = null;
  originalLocation = "";
  interactivePages: pbi.Page[] = [];
  public reportMainPage: pbi.Page = null;
  public reportLastPage: pbi.Page = null;
  reportPages: pbi.Page[] = null;
  currentPageIndex = -1;
  firstPage = false;
  lastPage = false;

  constructor(
    private userId: number | null,
    private userState: UserState,
    private dialog: MatDialog,
    private app: GlobalApp,
    private loadUserState: {(): Promise<UserState>},
    private subscriptionService: SubscriptionService,
    private interactiveId: string | undefined,
    private currentInteractive: US_Interactive,
    private embeddedReport: pbi.Report,
    private interactiveService: InteractivesService,
    private router: Router,
  ) {
  }

  refreshState(): Promise<void> {
    return new Promise<void>((resolve, error) => {
      this.loadUserState().then(result => {
        this.userState = result;
        this.currentInteractive = this.userState.interactives.find(x => x.interactId === this.currentInteractive.interactId);

        this.loadReports();
        this.loadReportExports();
        resolve();
      })
    });
  }

  public applyIfReport(reportId: string) {
    if (reportId !== null && reportId  !== '-1') {
      for (let i = 0; i < this.currentInteractive.availableReports.length; i++) {
        if (
          this.currentInteractive.availableReports[i].interactReportId.toString() === reportId) {
          this.startReport(this.currentInteractive.availableReports[i]);
          return;
        }
      }
    }
  }

  loadReports(): void {
    if (this.currentInteractive) {
      this.interactReports = this.currentInteractive.availableReports;
    }
  }

  loadReportExports(): void {
    if (this.currentInteractive) {
      this.interactReportExports = this.currentInteractive.currentReports;
    }
  }

  startReport(selectedReport: InteractReports): boolean {
    if (this.activeReport != null) {
      this.restoreEmbeddedState();
    }
    this.activeReport = selectedReport;
    this.showReport(this.activeReport.powerBIPrefix);
    return false;
  }

  showReport(reportPrefix: string) {
    const lowerPrefix = reportPrefix.toLowerCase().trim();

    this.embeddedReport.bookmarksManager.capture().then((bookmarkData) => {
      this.embeddedReport.getPages().then((allPages) => {
        this.originalLocation = JSON.stringify(bookmarkData);
        this.interactivePages = allPages;
        this.reportMainPage = null;
        this.reportPages = [];
        this.currentPageIndex = -1;
        this.firstPage = true;
        this.lastPage = false;

        for (let i = 0; i < this.interactivePages.length; i++) {
          const lowerDisplayName = this.interactivePages[i].displayName
            .toLowerCase()
            .trim();
          if (lowerDisplayName.startsWith(lowerPrefix + "_")) {
            if (lowerDisplayName.endsWith("start")) {
              this.reportMainPage = this.interactivePages[i];
            } else {
              this.reportPages.push(this.interactivePages[i]);
            }
          }
        }

        this.showReportMainPage();
      });
    });
  }

  showReportMainPage() {
    this.embeddedReport.setPage(this.reportMainPage.name);
  }

  showReportPage(pageNumber: number) {
    if (pageNumber !== this.currentPageIndex) {
      this.currentPageIndex = pageNumber;
      if (pageNumber === -1) {
        this.showReportMainPage();
      } else {
        this.embeddedReport.setPage(
          this.reportPages[this.currentPageIndex].name
        );
      }
    }

    if (pageNumber == this.reportPages.length - 1) {
      this.lastPage = true;
      this.firstPage = false;
    } else if (pageNumber == 0) {
      this.firstPage = true;
      this.lastPage = false;
    } else {
      this.firstPage = false;
      this.lastPage = false;
    }
  }

  restoreEmbeddedState(): void {
    this.embeddedReport.bookmarksManager.applyState(
      JSON.parse(this.originalLocation).state
    );
    this.originalLocation = "";
    this.interactivePages = [];
    this.reportMainPage = null;
    this.reportPages = null;
    this.currentPageIndex = -1;
    this.activeReport = null;
  }

  cancelExport(): boolean {
    if (this.userState.reportOnly) {
      this.router.navigate(["/"]).then(_ => {});
    } else {
      this.restoreEmbeddedState();
    }
    return false;
  }

  showNextPage(): boolean {
    const nextPage = this.currentPageIndex + 1;
    if (nextPage < this.reportPages.length) {
      this.showReportPage(nextPage);
    }
    return false;
  }

  showPrevPage(): boolean {
    const nextPage = this.currentPageIndex - 1;
    if (nextPage >= -1) {
      this.showReportPage(this.currentPageIndex - 1);
    }
    return false;
  }

  completeReport(): boolean {
    this.embeddedReport.bookmarksManager.capture().then((bookmarkData) => {
      const dialogData: ReportExportDialogData = {
        subInteractReportExportId: -1,
        description: "",
        isNewExport: true,
        name: "",
        shareState: { subscriptionShareStates: [] },
        subscriptionId: this.currentInteractive.subscriptionHeaders[0].subscriptionId,
        userSubscriptions: this.currentInteractive.subscriptionHeaders,
        exportFormat: "",
      };

      const dialogRef = this.dialog.open(ReportExportDialogComponent, {
        width: "600px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (
          result !== null &&
          result.ResultType !== null &&
          result.ResultType === DialogResultType.Ok
        ) {
          const ResultData = result.ResultData as ReportExportDialogData;

          const reportExportDetails: ReportExportDetails = {
            interactId: parseInt(this.interactiveId),
            interactReportId: this.activeReport.interactReportId,
            subscriptionid: ResultData.subscriptionId,
            bookmarkStateJson: JSON.stringify(bookmarkData),
            description: ResultData.description,
            fileFormat: ResultData.exportFormat,
            name: ResultData.name,
            reportPages: [],
          };

          for (let i = 0; i < this.reportPages.length; i++) {
            reportExportDetails.reportPages.push(this.reportPages[i].name);
          }

          this.app.pushLoading("Submitting Report Export");
          this.interactiveService
            .interactivesExportReportInteractive(reportExportDetails)
            .subscribe((exportResults) => {
              this.interactiveService
                .interactivesUpdateReportSharing({
                  SubInteractReportExportId:
                  exportResults.subInteractReportExportId,
                  updateSharingStatus: UserStateEx.getSharingStatus(
                    ResultData.shareState
                  ),
                })
                .subscribe((_) => {
                  if (this.userState.reportOnly) {
                    this.app.popLoading();
                    this.router.navigate(["/report-exports"]).then(_ => {});
                  } else {
                    this.refreshState().then(() => {
                      this.restoreEmbeddedState();
                      this.app.popLoading();
                    });

                    MessageDialogComponent.showDialog(
                      this.dialog,
                      "Success",
                      "Report Submitted"
                    );
                  }
                });
            });
        }
      });
    });

    return false;
  }

  downloadReportExport(selectedExport: SubInteractReportExports): boolean {
    if (selectedExport.status === 1) {
      this.interactiveService
        .interactivesGetReportExportDownloadUrl(
          selectedExport.subInteractReportExportId
        )
        .subscribe((resultUrl) => {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = resultUrl;
          a.download = selectedExport.fileId + "." + selectedExport.fileExt;
          a.click();
          window.URL.revokeObjectURL(resultUrl);
          a.remove();
        });
    }
    return false;
  }

  deleteReportExport(selectedExport: SubInteractReportExports): boolean {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete",
      "Are you sure you want to delete this report?"
    ).subscribe((result) => {
      if (result.ResultType == DialogResultType.Ok) {
        this.interactiveService
          .interactivesDeleteReportExport({
              subInteractReportExportId: selectedExport.subInteractReportExportId,
              userId: this.userId
            })
          .subscribe((_) => {
            this.refreshState().then(() => {
            })
          });
      }
    });

    return false;
  }

  editReportExport(selectedExport: US_ReportExport): boolean {
    if (selectedExport !== null && selectedExport.owner) {
      const dialogData: ReportExportDialogData = {
        subInteractReportExportId: selectedExport.subInteractReportExportId,
        description: selectedExport.description,
        isNewExport: false,
        name: selectedExport.name,
        shareState: UserStateEx.getReportExportShareState(
          this.userState,
          selectedExport
        ),
        subscriptionId: selectedExport.subscriptionId,
        userSubscriptions: this.currentInteractive.subscriptionHeaders,
        exportFormat: "",
      };

      const dialogRef = this.dialog.open(ReportExportDialogComponent, {
        width: "600px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (
          result !== null &&
          result.ResultType !== null &&
          result.ResultType === DialogResultType.Ok
        ) {
          const ResultData = result.ResultData as ReportExportDialogData;
          this.interactiveService
            .interactivesUpdateReportSharing({
              SubInteractReportExportId: ResultData.subInteractReportExportId,
              updateSharingStatus: UserStateEx.getSharingStatus(
                ResultData.shareState
              ),
            })
            .subscribe((_) => {
              this.refreshState().then(() => {
                this.restoreEmbeddedState();
              });
            });
        }
      });
    }
    return false;
  }
}
